import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const categories = [
  { id: 1, nameKey: "categories.rings", image: "/assets/Rings.png", path: "/products/rings" },
  { id: 2, nameKey: "categories.earrings", image: "/assets/Earrings.png", path: "/products/earrings" },
  { id: 3, nameKey: "categories.bracelets", image: "/assets/Bracelets.png", path: "/products/bracelets" },
  { id: 4, nameKey: "categories.necklaces", image: "/assets/Necklace.png", path: "/products/necklaces" },
  {id: 5, nameKey: " pandent", image: "/assets/pendent.png", path: "/products/pandent"}
];

function Categories() {
  const { t } = useTranslation("categories"); // Translation hook
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div className="container mx-auto px-6 py-12">
      {/* Subheading */}
      <h2 className="text-3xl font-bold text-center mb-8">
        {t("shop_by_category")} <br />
        <span className="text-lg text-gray-500">{t("subheading")}</span>
      </h2>

     {/* Categories Grid */}
<div
  className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6"
  data-aos="fade-up"
  data-aos-duration="1000"
>

        {categories.map((category) => (
          <div
            key={category.id}
            className="rounded-lg shadow-md overflow-hidden group cursor-pointer"
            onClick={() => handleCardClick(category.path)}
          >
            <img
              src={category.image}
              alt={t(category.nameKey)}
              className="w-full h-96 object-cover transform group-hover:scale-105 transition duration-300"
            />
          </div>
        ))}
      </div>

      {/* Diamond Collection Title at the Bottom */}
      <h1 className="text-4xl font-bold text-center mt-12 text-gray-900">
        {t("diamond_collection_title")}
      </h1>
    </div>
  );
}

export default Categories;
